/* tslint:disable no-magic-numbers */
export const getTenantId = () => getMetaContent('lias-tenant-id');
export const getTenantName = () => getMetaContent('lias-tenant-name');
export const getDocumentId = () => getMetaContent('lias-document-id');
export const getDocumentName = () => getMetaContent('lias-document-name');
export const getPageId = () => parseInt(getMetaContent('lias-page-id'), 10);
export const getPageName = () => getMetaContent('lias-page-name');
export const getPageNumber = () => parseInt(getMetaContent('lias-page-number').split('/')[0], 10);
export const getPageCount = () => parseInt(getMetaContent('lias-page-number').split('/')[1], 10);
export const getBreadcrumb = () => getMetaContent('lias-page-breadcrumb');
export const getMailToAddress = () => getMetaContent('lias-mailto-address');
export const getMailToName = () => getMetaContent('lias-mailto-name');
export const getTestNoteService = () => getMetaContent('lias-test-noteservice');

export const homePage = window.location.origin || `${window.location.protocol}//${window.location.host}`;

export const noteServiceUserApi = ((process.env.NODE_STAGE === 'development') ?
            'http://localhost:50455/api/user' : ((process.env.NODE_STAGE === 'test') ?
            'https://lias-webpub-noteservice-redesign-dev.azurewebsites.net/api/user' :
            'https://lias-webpub-noteservice-redesign.azurewebsites.net/api/user'));

function getMetaContent(name: string): string {
  const el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
  if (el) {
    return el.content;
  } else {
    return '';
  }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/settings/index.tsx